<template>
  <div class="app-container message-template-detail">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button v-show="isEdit" @click="cancelEdit">取消</el-button>
        <el-button type="primary" @click="switchMode">{{isEdit ? '保存' : '编辑'}}</el-button>
      </div>
      <el-row class="one-line" v-show="!isEdit">
        <el-col :span="2">ID：</el-col>
        <el-col :span="16">{{id}}</el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">分类：</el-col>
        <el-col :span="16" v-show="!isEdit">{{category}}</el-col>
        <el-col :span="16" v-show="isEdit">
          <el-input :maxlength="10" v-model="category"></el-input>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">问题：</el-col>
        <el-col :span="16" v-show="!isEdit">{{content}}</el-col>
        <el-col :span="16" v-show="isEdit">
          <el-input type="textarea" :rows="5" :maxlength="100" v-model="content"></el-input>
        </el-col>
      </el-row>
      <el-row class="one-line" v-show="!isEdit">
        <el-col :span="2">创建时间：</el-col>
        <el-col :span="16">{{insertedTime}}</el-col>
      </el-row>
    </basic-container>
  </div>
</template>
<script>
import { putObj, getObj } from '@/api/setting/template/messageTemplate'

const initDetail = vm => {
  getObj(vm.id).then(response => {
    if (response.data.code === 0) {
      formatData(vm, response.data.data)
    }
  }).catch(error => {
    console.error(error)
    vm.$message({
      message: '获取问题详情失败',
      type: 'error'
    })
  })
}

const formatData = (vm, data) => {
  vm.category = data.category
  vm.content = data.content
  vm.insertedTime = data.insertedTime
}

export default {
  data () {
    return {
      id: '',
      category: '',
      content: '',
      insertedTime: '',
      isEdit: false,
      loading: false
    }
  },
  watch: {
    $route () {
      this.isEdit = this.$route.path.includes('edit')
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted () {
    this.isEdit = this.$route.path.includes('edit')
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    cancelEdit () {
      if (this.$route.path.includes('edit')) {
        this.$router.$avueRouter.closeTag()
        this.$router.go(-1)
      } else {
        this.isEdit = false
        initDetail(this)
      }
    },
    switchMode () {
      if (this.isEdit) {
        this.submit()
      } else {
        this.isEdit = true
      }
    },
    validate () {
      if (!this.category) {
        this.$message({
          message: '分类不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.content) {
        this.$message({
          message: '内容不能为空',
          type: 'error'
        })
        return false
      }
      return true
    },
    getParams () {
      let params = {
        id: this.id,
        category: this.category,
        content: this.content
      }
      return params
    },
    submit () {
      if (!this.validate()) {
        return false
      }
      this.loading = true
      putObj(this.getParams()).then(response => {
        if (response.data.data) {
          this.loading = false
          if (this.$route.path.includes('edit')) {
            this.$router.$avueRouter.closeTag()
            this.$router.push({
              path: `/setting/template/message/detail/${this.id}`
            })
          } else {
            this.isEdit = false
          }
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        }
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '保存失败',
          type: 'error'
        })
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss">
.message-template-detail {
  .one-line {
    font-size: 16px;
    margin: 10px 0;
    line-height: 40px;
  }
  .operation {
    text-align: right
  }
}
</style>
